import {ConfiguredElement, ProductElementParam, ProductElementParamType} from "../../providers/product/product-types";
import {Range} from "../inputs/Range";
import React from "react";
import {useTranslation} from "react-i18next";

export interface SingleConfiguratorLineProps {
    index: number
    config: ConfiguredElement;
    element: ProductElementParam;
    changeConfigValue: (index: number, key: string, value: number | string) => void;
}

export const SingleConfiguratorLine = ({index, config, element, changeConfigValue}: SingleConfiguratorLineProps) => {
    const {t} = useTranslation();

    return (
        <div>
            {element.type === ProductElementParamType.HORIZONTAL_RANGE ? <Range
                title={t('CONFIG.' + element.name)}
                value={config.values[element.key] as number}
                onChange={(val) => changeConfigValue(index, element.key, val)}
                step={element.step}
                min={element.minValue}
                max={element.maxValue}
                unit={element.unit || ''}
                valMapper={val => element.valMapper(val)}
            /> : null}
            {element.type === ProductElementParamType.TEXT ? <>
                    <div className="mt-4">
                        <label htmlFor={element.key} className="block text-sm/6 font-medium text-gray-900">
                            {element.name}
                        </label>
                        <div className="mt-2">
                            <input
                                value={config.values[element.key]}
                                onChange={(evt) => changeConfigValue(index, element.key, evt.target.value)}
                                id={element.key}
                                name={element.key}
                                type="text"
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                            />
                        </div>
                    </div>
                </>
                : null}
        </div>
    )
}